import { createConfirmation } from 'react-confirm'
import ModalBody from "./ModalBody";
import Student from 'mediators/Student';

export const REFUND_CREDIT = 'refund_credit';
export const REFUND = 'refund';
export const ADD_CREDIT = 'add_credit';
export const CHARGE = 'charge';

const modal = createConfirmation(ModalBody);

export default function (opts = {}) {
  if (!opts.student) {
    throw new Error(`This modal requires a student object { student: a student object }`);
  }
  if (!opts.user_id) {
    throw new Error(`This modal requires an user_id`);
  }

  if (opts.classDetail) {

    // If classDetail.paidTotalFee is undefined, and paidInFee is present in student. It is
    // a situation where operation was under a student per class, for eg. ClassDetail page,
    // where students list are part of a classDetail.

    if (typeof opts.classDetail.paidTotalFee === 'undefined') {
      opts.classDetail.paidTotalFee = opts.student.paidInFee;
      opts.classDetail.classTotalFee = opts.classDetail.total_price;
    }

    opts.student.list = [opts.classDetail];

  }

  if (opts.student instanceof Student !== true) {
    opts.student = new Student(opts.student);
  }

  return modal(opts);
}



// WEBPACK FOOTER //
// ./src/template/Modals/NewPayment/index.js